import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import BlankSlate from 'modules/payroll_bundle/components/BlankSlate'

import setupImageUrl from '/src/assets/images/payroll/setup-empty-state/payroll-setup.png'

const RestrictionPage = () => {
  return (
    <ResponsivePage.Body showHeader={false}>
      <Box
        gap="s24"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        height="full"
        width="full"
      >
        <BlankSlate
          label={i18n.t('payroll_bundle.setup.blank_slate.title')}
          message={i18n.t(
            'payroll_bundle.setup.blank_slate.description_without_permission_to_setup'
          )}
          withIcon
          iconUrl={setupImageUrl}
          uploaded
        />
      </Box>
    </ResponsivePage.Body>
  )
}

export default RestrictionPage
